import React from "react";
import { SEO, MarkdownContent, DynamicForm } from "@bluefin/components";
import { Grid, Segment } from "semantic-ui-react";
import { graphql } from "gatsby";

import WebsiteLayout from "../components/WebsiteLayout.jsx";
import {
  getComponentFiles,
  getComponentContentNodeContent,
} from "../utils/utils";

export default class PhotoSubmissionPage extends React.PureComponent {
  render() {
    const { data } = this.props;
    const {
      fishermanBusiness,
      fishermanBusinessWebsitePage,
      lddbebieflfhfojkkdfifbgcmogdcoellddb,
    } = data;

    return (
      <WebsiteLayout>
        <SEO
          businessName={fishermanBusiness.name}
          pageName={fishermanBusinessWebsitePage.title}
          title={fishermanBusinessWebsitePage.seoTitle}
          description={fishermanBusinessWebsitePage.description}
          images={getComponentFiles({
            components: fishermanBusinessWebsitePage.components,
            componentName: "HeroElement",
            numToSelect: 1,
          })}
          ogUrl={"https://www.dupressalon.net/photo-submission/"}
        />
        <Grid
          className={"custom-page-photo-submission custom-page-grid"}
          style={{}}
          stackable={true}
        >
          <Grid.Row
            className={"ifbokcbhkbmpeejo"}
            style={{ padding: 16 }}
            columns={1}
          >
            <Grid.Column
              className={"oiigcjbjbkepedlc"}
              style={{ padding: 16 }}
              textAlign={"center"}
              verticalAlign={"middle"}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <MarkdownContent
                  className={"text-block"}
                  style={{}}
                  content={getComponentContentNodeContent({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "MarkdownContent",
                    componentId: "53aca5d7-664d-4784-9ad1-5fdd3e530669",
                    defaultValue: "",
                  })}
                />
              </Segment>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row
            className={"famlfgcolpmjefog"}
            style={{ padding: 16 }}
            textAlign={"center"}
          >
            <Grid.Column
              className={"ldcjnhongbijekhi"}
              style={{ padding: 16 }}
              width={8}
              textAlign={"left"}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <DynamicForm
                  className={""}
                  style={{}}
                  businessId={2634}
                  businessInfoId={7782}
                  websiteId={9286}
                  locationId={2847}
                  componentConfigurationId={224329}
                  header={lddbebieflfhfojkkdfifbgcmogdcoellddb.data.header}
                  fields={
                    lddbebieflfhfojkkdfifbgcmogdcoellddb.data.dynamicFormFields
                  }
                />
              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </WebsiteLayout>
    );
  }
}

export const query = graphql`
  query {
    fishermanBusiness {
      name
    }
    fishermanBusinessWebsitePage(_id: { eq: 39767 }) {
      title
      seoTitle
      description
      components {
        files {
          file
        }
        order
        fastId
        componentIdentifier
        contentNodes {
          content
        }
      }
    }
    lddbebieflfhfojkkdfifbgcmogdcoellddb: fishermanWebsiteComponent(
      fastId: { eq: "CustomForm" }
      componentIdentifier: { eq: "5e098d9e-91a2-4ec2-a492-e3bddbc732ff" }
    ) {
      data {
        header
        dynamicFormFields {
          name
          label
          style {
            color
            marginTop
            marginBottom
          }
          content
          options {
            label
            value
          }
          required
          inputType
          widgetType
          placeholder
          sendEmailToSelectedLocation
        }
      }
    }
  }
`;
